export function getFeaturedCaseImage(work) {
	const image = work.featured_case?.thumbnail_image || work.featured_case?.featured_image || work.thumbnail_image || work.featured_image

	if (image) {
		const { width, height } = image

		image.padding = `padding-top: ${(height / width) * 100}%`

		return image
	}

	return null
}